import React from "react";

import CardB from "./CardB";
import { type IBoardCardProps } from "./type";

function BoardCard(props: IBoardCardProps & { boardType?: "new" }) {
  return <CardB {...props} />;
}

export default React.memo(BoardCard);
